'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    renterHubWeb: {
        id: 'renterHubWeb',
        feLogUrl: '/renter-hub/proxy/renter-hub-api/api/clientError/log'
    },
    rentalManagerWeb: {
        id: 'rentalManagerWeb',
        feLogUrl: '/rental-manager/proxy/rental-manager-api/api/v1/capps/clientError/log'
    }
};
//# sourceMappingURL=project.js.map